import {Action} from "redux";
import {
    CreateClientByClientRequest, DeleteClientByClientRequest,
    GetAllClientsByClientRequest,
    UpdateRoleClientByClientRequest
} from "../request/clients_request";
import {
    CreateClientByClientResponse, DeleteClientByClientResponse,
    GetAllClientsByClientResponse,
    UpdateRoleClientByClientResponse
} from "../response/clients_response";

export enum ClientClientsActionType {
    REQUEST_GET_ALL_CLIENTS = "CLIENT_CLIENTS_REQUEST_GET_ALL_CLIENTS",
    CALLBACK_GET_ALL_CLIENTS = "CLIENT_CLIENTS_CALLBACK_GET_ALL_CLIENTS",

    REQUEST_CREATE_CLIENT = "CLIENT_CLIENTS_REQUEST_CREATE_CLIENT",
    CALLBACK_CREATE_CLIENT = "CLIENT_CLIENTS_CALLBACK_CREATE_CLIENT",

    REQUEST_UPDATE_ROLE_CLIENT = "CLIENT_CLIENTS_REQUEST_UPDATE_ROLE_CLIENT",
    CALLBACK_UPDATE_ROLE_CLIENT = "CLIENT_CLIENTS_CALLBACK_UPDATE_ROLE_CLIENT",

    REQUEST_DELETE_CLIENT = "CLIENT_CLIENTS_REQUEST_DELETE_CLIENT",
    CALLBACK_DELETE_CLIENT = "CLIENT_CLIENTS_CALLBACK_DELETE_CLIENT",
}

export interface IRequestGetAllClientsAction extends Action {
    type: ClientClientsActionType.REQUEST_GET_ALL_CLIENTS;
    item: GetAllClientsByClientRequest,
}

export interface ICallbackGetAllClientsAction extends Action {
    type: ClientClientsActionType.CALLBACK_GET_ALL_CLIENTS;
    isSuccess: boolean;
    item?: GetAllClientsByClientResponse;
    error?: any;
}

export interface IRequestCreateClientAction extends Action {
    type: ClientClientsActionType.REQUEST_CREATE_CLIENT;
    item: CreateClientByClientRequest,
}

export interface ICallbackCreateClientAction extends Action {
    type: ClientClientsActionType.CALLBACK_CREATE_CLIENT;
    isSuccess: boolean;
    item?: CreateClientByClientResponse;
    error?: any;
}

export interface IRequestUpdateRoleClientAction extends Action {
    type: ClientClientsActionType.REQUEST_UPDATE_ROLE_CLIENT;
    item: UpdateRoleClientByClientRequest,
}

export interface ICallbackUpdateRoleClientAction extends Action {
    type: ClientClientsActionType.CALLBACK_UPDATE_ROLE_CLIENT;
    isSuccess: boolean;
    item?: UpdateRoleClientByClientResponse;
    error?: any;
}

export interface IRequestDeleteClientAction extends Action {
    type: ClientClientsActionType.REQUEST_DELETE_CLIENT;
    item: DeleteClientByClientRequest,
}

export interface ICallbackDeleteClientAction extends Action {
    type: ClientClientsActionType.CALLBACK_DELETE_CLIENT;
    isSuccess: boolean;
    item?: DeleteClientByClientResponse;
    error?: any;
}

export type ClientClientsAction =
    IRequestGetAllClientsAction |
    ICallbackGetAllClientsAction |
    IRequestCreateClientAction |
    ICallbackCreateClientAction |
    IRequestUpdateRoleClientAction |
    ICallbackUpdateRoleClientAction |
    IRequestDeleteClientAction |
    ICallbackDeleteClientAction
    ;

export interface IClientClientsActionCreator {
    requestGetAllClientsAction(
        item: GetAllClientsByClientRequest,
    ): IRequestGetAllClientsAction;

    callbackGetAllClientsAction(
        isSuccess: boolean,
        item?: GetAllClientsByClientResponse,
        error?: any,
    ): ICallbackGetAllClientsAction;

    requestCreateClientAction(
        item: CreateClientByClientRequest,
    ): IRequestCreateClientAction;

    callbackCreateClientAction(
        isSuccess: boolean,
        item?: CreateClientByClientResponse,
        error?: any,
    ): ICallbackCreateClientAction;

    requestUpdateRoleClientAction(
        item: UpdateRoleClientByClientRequest,
    ): IRequestUpdateRoleClientAction;

    callbackUpdateRoleClientAction(
        isSuccess: boolean,
        item?: UpdateRoleClientByClientResponse,
        error?: any,
    ): ICallbackUpdateRoleClientAction;

    requestDeleteClientAction(
        item: DeleteClientByClientRequest,
    ): IRequestDeleteClientAction;

    callbackDeleteClientAction(
        isSuccess: boolean,
        item?: DeleteClientByClientResponse,
        error?: any,
    ): ICallbackDeleteClientAction;
}

class ActionCreator implements IClientClientsActionCreator {
    public requestGetAllClientsAction = (
        item: GetAllClientsByClientRequest
    ): IRequestGetAllClientsAction => {
        return {
            type: ClientClientsActionType.REQUEST_GET_ALL_CLIENTS,
            item,
        }
    };

    public callbackGetAllClientsAction = (
        isSuccess: boolean,
        item?: GetAllClientsByClientResponse,
        error?: any
    ): ICallbackGetAllClientsAction => {
        return {
            type: ClientClientsActionType.CALLBACK_GET_ALL_CLIENTS,
            isSuccess,
            item,
            error,
        }
    };

    public requestCreateClientAction = (
        item: CreateClientByClientRequest,
    ): IRequestCreateClientAction => {
        return {
            type: ClientClientsActionType.REQUEST_CREATE_CLIENT,
            item,
        };
    };

    public callbackCreateClientAction = (
        isSuccess: boolean,
        item: CreateClientByClientResponse,
        error?: any,
    ): ICallbackCreateClientAction => {
        return {
            type: ClientClientsActionType.CALLBACK_CREATE_CLIENT,
            isSuccess,
            item,
            error,
        };
    };

    public requestUpdateRoleClientAction = (
        item: UpdateRoleClientByClientRequest,
    ): IRequestUpdateRoleClientAction => {
        return {
            type: ClientClientsActionType.REQUEST_UPDATE_ROLE_CLIENT,
            item,
        };
    };

    public callbackUpdateRoleClientAction = (
        isSuccess: boolean,
        item: UpdateRoleClientByClientResponse,
        error?: any,
    ): ICallbackUpdateRoleClientAction => {
        return {
            type: ClientClientsActionType.CALLBACK_UPDATE_ROLE_CLIENT,
            isSuccess,
            item,
            error,
        };
    };

    public requestDeleteClientAction = (
        item: DeleteClientByClientRequest,
    ): IRequestDeleteClientAction => {
        return {
            type: ClientClientsActionType.REQUEST_DELETE_CLIENT,
            item,
        };
    };

    public callbackDeleteClientAction = (
        isSuccess: boolean,
        item: DeleteClientByClientResponse,
        error?: any,
    ): ICallbackDeleteClientAction => {
        return {
            type: ClientClientsActionType.CALLBACK_DELETE_CLIENT,
            isSuccess,
            item,
            error,
        };
    };
}

export const createClientClientsActionCreator = (): IClientClientsActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_clients_action.ts